// extracted by mini-css-extract-plugin
export default {"box":"QuestionPoints_box__B6H+1","span":"QuestionPoints_span__dPU4X","input":"QuestionPoints_input__hMhCn"};